var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.044,
    height: 62.044,
    viewBox: "0 0 62.044 62.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#453878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6154c7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-161.746 -91.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 31.022,
    cy: 31.022,
    r: 31.022,
    transform: "translate(161.746 91.603)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M210.624,118.794l0,0-15.4-15.4a3.474,3.474,0,0,0-4.914,0l-15.388,15.388-.016.016a3.474,3.474,0,0,0,2.313,5.92c.035,0,.071,0,.107,0h.614v11.33a4.071,4.071,0,0,0,4.066,4.067h6.024a1.106,1.106,0,0,0,1.106-1.106v-8.883a1.857,1.857,0,0,1,1.855-1.855h3.553a1.857,1.857,0,0,1,1.855,1.855v8.883a1.106,1.106,0,0,0,1.106,1.106h6.024a4.072,4.072,0,0,0,4.067-4.067v-11.33h.569a3.474,3.474,0,0,0,2.458-5.93Z",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnHome);
export default __webpack_public_path__ + "static/media/btn-home.378c6d642bca11f3c553a709fc3da62a.svg";
export { ForwardRef as ReactComponent };